<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>

      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>

      <template v-slot:cell(action)="data">
        <b-link @click="onClickView(data.item.id)"
          ><i class="ti-file" style="font-size:20px;"></i
        ></b-link>
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      items: [],
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Date", value: "2" }
        ]
      },
      filter2: null,
      form: {
        name: null,
        date: null,
        page: 1
      },
      indexsearch: 1,
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      isLoading: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.type === "sub" && this.tab !== "4") {
      this.getDOSub();
      return;
    }

    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;
      this.form.date = this.date !== "null" ? this.date : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        if (this.type === "main") {
          this.getDO();
        } else if (this.type === "sub") {
          this.getDOSub();
        }
      }
    } else {
      if (this.type === "main") {
        this.getDO();
      } else if (this.type === "sub") {
        this.getDOSub();
      }
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },

    state: {
      type: Number,
      required: false
    },

    type: {
      type: String,
      required: true
    },

    user_id: {
      type: Number
    },

    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    name: {
      type: String
    },
    date: {
      type: String
    },
    tab: {
      type: String
    }
  },
  methods: {
    onClickView(id) {
      if (this.type === "sub") {
        this.$router.push({
          path: `viewDO?id=${id}&cat=4&state=${this.state}&upline=${this.user_id}&type=${this.type}&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&name=${this.form.name}&outlet_name=null&email=null`
        });
      } else {
        this.$router.push({
          path: `viewDO?id=${id}&cat=4&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&name=${this.form.name}`
        });
      }
    },
    resetFilter() {
      this.form.date = null;
      this.form.name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.form.date = null;
      this.pagination.current = 1;
      if (this.type === "main") {
        this.getDO();
      } else if (this.type === "sub") {
        this.getDOSub();
      }
    },
    getDO() {
      this.isLoading = true;
      this.$store.dispatch("getDOList", this.pagination.current).then(res => {
        this.isLoading = false;
        this.items = [];
        res.data.data.data.forEach(element => {
          this.items.push({
            date: element.date,
            type: element.type,
            name: element.userdetails !== null ? element.userdetails.name : "",
            status: element.status_details.desc,
            statusid: element.status,
            id: element.delivery_id,
            purchase_id: element.purchase_id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },

    getDOSub() {
      this.isLoading = true;
      let url = `user/downlinestock/deliveodr?user_id=${this.user_id}&page=${this.pagination.current}`;

      this.$store.dispatch("getDOSubDAdmin", url).then(res => {
        this.isLoading = false;
        this.items = [];
        res.data.data.data.forEach(element => {
          this.items.push({
            date: element.date,
            type: element.type,
            name: element.userdetails !== null ? element.userdetails.name : "",
            status: element.status_details.desc,
            statusid: element.status,
            id: element.delivery_id,
            purchase_id: element.purchase_id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },
    onClickSearch() {
      this.isLoading = true;
      if (this.filter2 === null) {
        if (this.type === "main") {
          this.getDO();
        } else if (this.type === "sub") {
          this.getDOSub();
        }
      } else {
        if (this.type === "main") {
          this.form.page = this.indexsearch;
          this.$store.dispatch("searchDO", this.form).then(res => {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                date: element.date,
                type: element.type,
                name:
                  element.userdetails !== null ? element.userdetails.name : "",
                status: element.status_details.desc,
                statusid: element.status,
                id: element.delivery_id,
                purchase_id: element.purchase_id
              });
            });
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
            this.indexsearch = res.data.data.current_page;
          });
        } else if (this.type === "sub") {
          this.form.page = this.indexsearch;
          let url = "";
          if (this.form.date) {
            url = `user/downlinestock/deliveodr?user_id=${this.user_id}&page=${this.pagination.current}&date=${this.form.date}`;
          }
          if (this.form.name) {
            url = `user/downlinestock/deliveodr?user_id=${this.user_id}&page=${this.pagination.current}&name=${this.form.name}`;
          }

          this.$store.dispatch("getDOSubDAdmin", url).then(res => {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                date: element.date,
                type: element.type,
                name:
                  element.userdetails !== null ? element.userdetails.name : "",
                status: element.status_details.desc,
                statusid: element.status,
                id: element.delivery_id,
                purchase_id: element.purchase_id
              });
            });
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
            this.indexsearch = res.data.data.current_page;
          });
        }
      }
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        if (this.type === "main") {
          this.getDO();
        } else if (this.type === "sub") {
          this.getDOSub();
        }
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
